module.exports = __webpack_public_path__ + "static/Olivier.1882d11e.jpeg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/team/Olivier.jpeg
// module id = 940
// module chunks = 3